import clsx from 'clsx';

export function ArrowsUpDownIcon({ className, ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={clsx(className)}
      {...props}
    >
      <path
        d="M13.4143 22.3137L16.9499 18.7782C17.3388 18.3892 17.3388 17.7528 16.9499 17.3639C16.561 16.975 15.9246 16.975 15.5356 17.3639L12.9971 19.9025V13.8355C12.9971 13.2839 12.5517 12.8385 12.0001 12.8385C11.4486 12.8385 11.0031 13.2839 11.0031 13.8355V19.9025L8.46458 17.3639C8.07567 16.975 7.43928 16.975 7.05037 17.3639C6.66146 17.7528 6.66146 18.3892 7.05037 18.7782L10.5859 22.3137C11.3637 23.0915 12.6294 23.0986 13.4143 22.3137Z"
        fill="currentColor"
      />
      <path
        d="M10.5859 1.68631L7.05037 5.22185C6.66146 5.61076 6.66146 6.24715 7.05037 6.63606C7.43928 7.02497 8.07567 7.02497 8.46458 6.63606L11.0031 4.09755V10.1645C11.0031 10.7161 11.4486 11.1615 12.0001 11.1615C12.5517 11.1615 12.9971 10.7161 12.9971 10.1645V4.09755L15.5356 6.63606C15.9246 7.02497 16.561 7.02497 16.9499 6.63606C17.3388 6.24715 17.3388 5.61076 16.9499 5.22185L13.4143 1.68631C12.6365 0.908497 11.3708 0.901426 10.5859 1.68631Z"
        fill="currentColor"
      />
    </svg>
  );
}
